'use client';

import { useEffect } from 'react';
import { trackViewItem, trackAddToCart } from '@/libs/dataLayer';

/**
 * Client component that sets up global dataLayer tracking functions
 * This makes tracking functions available to shared packages like catalog and cart
 */
export default function DataLayerSetup() {
	useEffect(() => {
		// Expose tracking functions globally so shared packages can use them
		if (typeof window !== 'undefined') {
			// console.log('DataLayerSetup');
			window.trackViewItem = (product, options = {}) => {
				trackViewItem(product, options);
			};

			window.trackAddToCart = (item) => {
				trackAddToCart(item);
			};
		}

		return () => {
			if (typeof window !== 'undefined') {
				if (window.trackViewItem) delete window.trackViewItem;
				if (window.trackAddToCart) delete window.trackAddToCart;
			}
		};
	}, []);

	return null;
}
